// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IO-z","hovered":"JO-z","hoverImage":"KO-z","mainImage":"LO-z","imageNoBackground":"MO-z","fullSizeImage":"NO-z"};